import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import Contests, { Contest } from '../../../../../presentation/pages/doctors/contests'

import { makeContestsVacancies } from '../../../../usecases/contests-vacancies/remote-contests-vacancies-factory'

const MakeContests = () => {
  const [contests, setContests] = useState<Contest[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchContests = async () => {
      try {
        setLoading(true)
        setError(null)

        const contestsService = makeContestsVacancies('concursos')
        const response = await contestsService.load()

        let contestsData: Contest[] = []

        if (Array.isArray(response)) {
          contestsData = response
        } else if (Array.isArray(response.content)) {
          contestsData = response.content
        }

        setContests(contestsData)
      } catch (err) {
        console.error('Error fetching contests:', err)
        setError('Erro ao carregar concursos. Tente novamente mais tarde.')
        toast.error('Erro ao carregar concursos.')
      } finally {
        setLoading(false)
      }
    }

    fetchContests()
  }, [])

  return <Contests contests={contests} loading={loading} error={error} />
}

export default MakeContests
